import { render, staticRenderFns } from "./verify-otp.vue?vue&type=template&id=5577113a&scoped=true"
import script from "./verify-otp.vue?vue&type=script&lang=js"
export * from "./verify-otp.vue?vue&type=script&lang=js"
import style0 from "./verify-otp.vue?vue&type=style&index=0&id=5577113a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5577113a",
  null
  
)

export default component.exports